import React, { useEffect, useState } from "react";
import { listStaff } from "../api/staffApi";
import "../pages/Attendance/Attendance.css";

/**
 * Staff-search equivalent of `StudentPicker` — the real old app looks a
 * staff member up by typing their Custom Staff ID (`/staff/report/single/view
 * ?customStaffId=`); this app doesn't have a staff roster small enough per
 * page to need that same narrowing dance the student picker does (a single
 * institute rarely has more than a few dozen staff, confirmed against real
 * institute-1 data — 34), so one plain searchable dropdown over the already-
 * existing `GET /api/staff` covers the same "find one staff member without
 * knowing their internal id" need. Fires `onSelect(staffResponseOrNull)`.
 */
export default function StaffPicker({ onSelect }) {
  const [staff, setStaff] = useState([]);
  const [staffId, setStaffId] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listStaff()
      .then(setStaff)
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const s = staff.find((x) => String(x.staffId) === staffId) || null;
    onSelect(s);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [staffId, staff]);

  return (
    <div className="attendance-filters">
      <label>
        Staff
        <select value={staffId} onChange={(e) => setStaffId(e.target.value)} disabled={loading}>
          <option value="">{loading ? "Loading..." : "Select a staff member"}</option>
          {staff.map((s) => (
            <option key={s.staffId} value={s.staffId}>
              {s.staffName} ({s.customStaffId})
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}
